import { motion } from "framer-motion";
import {
  TreePine, Sprout, Home, Hammer, PaintRoller, Sparkles,
  Droplets, Zap, Thermometer, Layers, Fence, HardHat, Wrench, Waves,
} from "lucide-react";
import { toast } from "sonner";

const ICONS = {
  "tree-pine": TreePine, sprout: Sprout, home: Home, hammer: Hammer,
  "paint-roller": PaintRoller, sparkles: Sparkles, droplets: Droplets,
  zap: Zap, thermometer: Thermometer, layers: Layers, fence: Fence,
  "hard-hat": HardHat, waves: Waves, wrench: Wrench,
};

const ease = [0.22, 1, 0.36, 1];

export const Categories = ({ categories }) => (
  <section id="services" className="bg-[#F4F5F7] border-y border-border py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex items-end justify-between mb-16 flex-wrap gap-6">
        <div>
          <p className="uppercase tracking-[0.25em] text-flame font-heading font-bold text-sm mb-4">01 — Services</p>
          <h2 data-testid="categories-heading" className="font-heading font-black tracking-tighter text-navy text-3xl sm:text-4xl lg:text-5xl">
            Popular service categories
          </h2>
        </div>
        <p className="text-slate-500 max-w-sm text-base">
          Every category is managed by our team and grows with verified local providers.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="categories-grid">
        {categories.map((c, i) => {
          const Icon = ICONS[c.icon] || Wrench;
          return (
            <motion.button
              key={c.id}
              data-testid={`category-card-${c.slug}`}
              onClick={() => toast.info(`${c.name} pros are being onboarded in your area.`)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease }}
              className="group relative bg-white border border-border p-6 lg:p-8 text-left hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300"
            >
              <span className="absolute top-0 left-0 w-0 h-1 bg-flame group-hover:w-full transition-[width] duration-300" />
              <Icon size={28} className="text-navy group-hover:text-flame transition-colors" strokeWidth={1.75} />
              <p className="font-heading font-bold text-navy mt-5 text-base lg:text-lg tracking-tight">{c.name}</p>
            </motion.button>
          );
        })}
      </div>
    </div>
  </section>
);

export default Categories;
